enum ECurrencyType {
    FIAT = 'fiat',
    CRYPTO = 'crypto',
}

export { ECurrencyType }
